var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.043 16.305a8.03 8.03 0 1 1 1.262-1.262L22 20.738 20.738 22l-5.695-5.695ZM3.785 10.031a6.246 6.246 0 1 1 10.746 4.331l-.169.169a6.246 6.246 0 0 1-10.578-4.5Z",
    fill: "currentColor"
  })));
};
export { SvgSearch as ReactComponent };
export default __webpack_public_path__ + "145461de5df7e5327469297b6bdb9d9b.svg";